/**
 * Send "wattage updates" (can be temperature, humidity and water as well) to apps
 *
 * @param {Number} wattage
 * @param {Number} roundFactor - Round to this many decimal places
 */
const wattageUpdate = (wattage = null, roundFactor = 1) => {
    wattage = Math.round(wattage * roundFactor) / roundFactor

    if (window?.webkit?.messageHandlers?.wattageUpdate) {
        window.webkit.messageHandlers.wattageUpdate.postMessage(wattage)
    } else if (typeof Android !== "undefined" && Android?.wattageUpdate) {
        Android.wattageUpdate(wattage)
    }
}

export { wattageUpdate }
